import {HttpClient} from 'aurelia-http-client';
import {autoinject} from 'aurelia-dependency-injection';
import { AttachmentInfo } from "../entities/entities";
import  toJson from "../../core/to-json";

@autoinject
export class AttachmentDataServiceX {

    baseUrl: string = 'attachments/';

    constructor(private http: HttpClient) {

    }

    //searchAttachmentInfos(searchText, parentGuid) {
    //    return this.http.post(this.baseUrl + "search?parentGuid=" + parentGuid, toJson(searchText));
    //}

    listAttachments(parentGuid: string, entityStatusId:number) {
       return this.http.get(this.baseUrl + "list?parentGuid=" + parentGuid + "&entityStatusId=" + entityStatusId);
    }

    save(attachmentInfo: AttachmentInfo) {
        return this.http.post(this.baseUrl + "save", attachmentInfo);
    }
}